import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils/schema';
import { AlgorithmTargetRuleType } from '../../../../dataobject/types';
import { encodeRuleSourceItemValue, encodeRuleTargetItemValue } from '../utils';
import { AlgorithmTargetItemFormDataSchema } from './AlgorithmTargetItemFormDataSchema';
import { AlgorithmSourceFormDataSchema } from '../../sources/schema/AlgorithmSourceFormDataSchema';
import { AlgorithmMappingQueryDtoSchema } from '../../mappings/schema/AlgorithmMappingQueryDtoSchema';
import {
  AlgorithmTargetItemFormDataType,
  AlgorithmTargetItemQueryDtoType,
} from './types';

export const AlgorithmTargetRuleFormDataSchema = z
  .object({
    id: transformNullish<number>(z.number(), -1),
    ruleType: z.nativeEnum(AlgorithmTargetRuleType),
    ruleCode: transformNullish<string>(z.string(), ''),
    sourceItemCode: transformNullish<string>(z.string(), ''),
    subjectFieldCodeId: transformNullish<number | undefined>(
      z.number(),
      undefined,
    ),
    expression: transformNullish<string>(z.string(), ''),
    algorithmTargetId: transformNullish<number | undefined>(
      z.number(),
      undefined,
    ),
    algorithmId: transformNullish<number | undefined>(z.number(), undefined),
    algorithmSourceId: transformNullish<number | undefined>(
      z.number(),
      undefined,
    ),
    algorithmSource: AlgorithmSourceFormDataSchema.nullish(),
    algorithmMappingId: transformNullish<number | undefined>(
      z.number(),
      undefined,
    ),
    algorithmMapping: AlgorithmMappingQueryDtoSchema.nullish(),
    items: transformNullish<
      AlgorithmTargetItemFormDataType[],
      AlgorithmTargetItemQueryDtoType[]
    >(AlgorithmTargetItemFormDataSchema.array(), []),
  })
  .transform(({ ...data }) => {
    let sourceItem = '';

    if (data.algorithmSourceId) {
      sourceItem = encodeRuleSourceItemValue({
        algorithmSourceId: data.algorithmSourceId,
        sourceItemCode: data.sourceItemCode,
      });
      delete data.algorithmMappingId;
      delete data.algorithmMapping;
    } else if (data.algorithmMappingId) {
      sourceItem = encodeRuleSourceItemValue({
        algorithmMappingId: data.algorithmMappingId,
      });
      delete data.algorithmSourceId;
      delete data.algorithmSource;
    } else {
      delete data.algorithmSourceId;
      delete data.algorithmSource;
      delete data.algorithmMappingId;
      delete data.algorithmMapping;
    }

    return {
      dimensionIndicators: data.items.map((item) =>
        encodeRuleTargetItemValue(
          item.dimensionCode
            ? {
                code: item.dimensionCode,
                dimensionType: {} as any,
              }
            : {
                code: item.indicatorCode,
              },
          Boolean(item.confidentialityStatus),
        ),
      ),
      sourceItem,
      ...data,
    };
  });
